import type { SidebarItem } from '@bv/router';

const sidebarItems: SidebarItem[] = [
  {
    title: 'Providers',
    route: { name: 'cl-providers-list' },
  },
  {
    title: 'Numbers',
    route: { name: 'cl-numbers-list' },
  },
  {
    title: 'Call Details Report',
    route: { name: 'cl-details-report' },
  },
  {
    title: 'Authentications',
    route: { name: 'cl-authentications' },
  },
  {
    title: 'Servers',
    route: { name: 'cl-servers' },
    permissions: 'cloud-lines-read-servers',
  },
];

export default sidebarItems;
